import {
    ISeriesPrimitive,
    ISeriesPrimitiveAxisView,
    ISeriesPrimitivePaneView,
    PrimitiveHoveredItem,
    SeriesAttachedParameter,
    SeriesOptionsMap,
    Time
} from 'lightweight-charts'
import DrawingBase from './drawing.base'

export type DrawingPrimitiveOptions = {
    drawing: DrawingBase<any, any, any>
}

class DrawingPrimitive implements ISeriesPrimitive<Time> {
    private _drawing: DrawingBase<any, any, any>

    requestUpdate() {
    };

    constructor(options: DrawingPrimitiveOptions) {
        this._drawing = options.drawing
    }

    attached(param: SeriesAttachedParameter<Time, keyof SeriesOptionsMap>): void {
        const { requestUpdate } = param
        this.requestUpdate = requestUpdate
    }

    paneViews(): readonly ISeriesPrimitivePaneView[] {
        if (this._drawing._destroyed) return []
        return this._drawing.getPaneViews()
    }

    priceAxisPaneViews(): readonly ISeriesPrimitivePaneView[] {
        if (this._drawing._destroyed || (!this._drawing._active && this._drawing.mode !== 'DRAW' && !this._drawing.fixedDrawing)) return []
        return this._drawing.getPriceAxisPaneViews()
    }

    timeAxisPaneViews(): readonly ISeriesPrimitivePaneView[] {
        if (this._drawing._destroyed || (!this._drawing._active && this._drawing.mode !== 'DRAW' && !this._drawing.fixedDrawing)) return []
        return this._drawing.getTimeAxisPaneViews()
    }

    priceAxisViews(): readonly ISeriesPrimitiveAxisView[] {
        if (this._drawing._destroyed || (!this._drawing._active && this._drawing.mode !== 'DRAW' && !this._drawing.fixedDrawing)) return []
        return this._drawing.getPriceAxisLabels()
    }

    timeAxisViews(): readonly ISeriesPrimitiveAxisView[] {
        if (this._drawing._destroyed || (!this._drawing._active && this._drawing.mode !== 'DRAW' && !this._drawing.fixedDrawing)) return []
        return this._drawing.getTimeAxisLabels()
    }

    hitTest(x: number, y: number): PrimitiveHoveredItem | null {
        if (this._drawing._destroyed) return null
        return this._drawing._hitTest(x, y)
    }
}

export default DrawingPrimitive